import DynamicUIContext from '@Contexts/DynamicUIContext';
import { useContext } from 'react';

export const useDynamicUI = () => {
    const { open } = useContext(DynamicUIContext);
    return open;
};
